// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthForm_wrapper__1yo9N","note":"AuthForm_note__V34jm","item":"AuthForm_item__+qPdH","footer":"AuthForm_footer__cHlYZ","privacyRow":"AuthForm_privacyRow__H9qOa"};